import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';


@Injectable({
  providedIn: 'root'
})
export class MedicineService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
      const token = localStorage.getItem('jwtToken');
      return {
        headers: new HttpHeaders({
          'Authorization' : `Bearer ${token}`
        })
      }
    }

  getMedicine() {
    return this.http.get(
      // this.common.getBaseUrl() + 'Medicine.php?action=MedicineList' + (payload ? '&list=all' : '')
      this.apiUrl + '/medicine', this.getAuthHeaders()
    );
  }

  suggestMedicineCode(
    name: string,
    options?: { excludeId?: string | number; potency?: string; scale?: string },
  ) {
    let params = new HttpParams();
    if (name?.trim()) {
      params = params.set('name', name.trim());
    }
    if (options?.potency?.trim()) {
      params = params.set('potency', options.potency.trim());
    }
    if (options?.scale?.trim()) {
      params = params.set('scale', options.scale.trim());
    }
    if (options?.excludeId !== undefined && options?.excludeId !== null && String(options.excludeId) !== '') {
      params = params.set('exclude_id', String(options.excludeId));
    }

    return this.http.get(this.apiUrl + '/medicine/suggest-code', {
      ...this.getAuthHeaders(),
      params,
    });
  }

  addMedicine(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addMedicine";
    // return this.http.post(this.common.getBaseUrl() + 'Medicine.php', payload);
    return this.http.post(this.apiUrl + '/medicine', payload, this.getAuthHeaders());
  }

  updateMedicine(payload: any) {
    payload["action"] = "updateMedicine";
    // return this.http.put(this.common.getBaseUrl() + 'Medicine.php', payload);
    return this.http.put(this.apiUrl + '/medicine/' + payload.id, payload, this.getAuthHeaders());
  }

  deleteMedicine(payload: any) {
    payload["action"] = "deleteMedicine";
    return this.http.delete(this.apiUrl + '/medicine/' + payload.id, this.getAuthHeaders());
  }
}
